module.exports = __webpack_public_path__ + "img/5.cfac9446.png";